import { Component, OnInit, ViewChild, Inject, OnDestroy, AfterViewInit  } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { MatDialogRef } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-busqueda-x-nombre',
  templateUrl: './busqueda-x-nombre.component.html',
  styleUrls: ['./busqueda-x-nombre.component.scss']
})
export class BusquedaXNombreComponent implements OnInit, OnDestroy, AfterViewInit  {

  /**
   * Variables DataTable
   */
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective, {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  newForm: FormGroup;

  /**
   * Constructor
   * 
   * @param {CarteraService} _cartera 
   * @param {MatDialogRef<BusquedaXNombreComponent>} dialog 
   */
  constructor
  (
    private _cartera: CarteraService, 
    private dialog: MatDialogRef<BusquedaXNombreComponent>
  ) 
  { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.newForm = this.createForm();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this.dtOptions = {
      language: {
        lengthMenu: "_MENU_ Registros por página",
        zeroRecords: "Persona inexistente en el sistema",
        info: "Mostrando la página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(Filtrado de _MAX_ registros totales)",
        LoadingRecords: "Cargando...",
        search: "Buscar:",
        paginate: {
          first:   "Primero",
          last:    "Último",
          next:    "Siguiente",
          previous:"Anterior" 
        }
      },
      columns: [
        {
          title: ''
        },
        {
          title: 'Empresa',
          data: 'empresa'
        },
        {
          title: 'Documento',
          data: 'documento_grupo'
        },
        {
          title: 'Radicado',
          data: 'radicado_grupo'
        },
        {
          title: 'Nombre Completo',
          data: 'nombre_grupo'
        }
      ],
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        $('.add', row).unbind('click');
        $('.add', row).bind('click', (e) => {
            self.someClickHandler(data);
        });
        return row;
      },
    }
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toma el radicado y empresa del grupo seleccionado y lo retorna al componente padre
   * @param {any} info 
   */
  someClickHandler(info: any): void{
    const INFOGRUPO = {
      radicado: info.radicado_grupo,
      empresa: info.empresa === 'VitalMascotas'? '1' : '0'
    }
    this.dialog.close(INFOGRUPO);
  }

  /**
   * Creación del FormGroup
   * @returns {FormGroup}
   */
  createForm(): FormGroup{
    return new FormGroup({
      nombre: new FormControl('', [
        Validators.pattern('^[a-zA-Z ]+$'),
        Validators.required
      ])
    });
  }

  /**
   * Trae la lista de nombres que coinciden con el dato suministrado
   * @param {any} form 
   */
  public buscarNombreGrupo(form: any): void{
    this._cartera.VerNombreGrupo(form.nombre).subscribe((data: any) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  /**
   * Renderiza la tabla
   */
  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
